
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-spins/[date]",
      function () {
        return require("private-next-pages/top-spins/[date].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-spins/[date]"])
      });
    }
  